import { useQuery } from '@tanstack/react-query';
import { getSubscriptions, getChangelog } from '../api/subscriptions';
import type { Subscription, ChangelogEntry } from '../types';

export function useSubscriptions(options?: {
  refetchInterval?: number | false | ((query: { state: { data: Subscription[] | undefined } }) => number | false);
}) {
  return useQuery<Subscription[]>({
    queryKey: ['subscriptions'],
    queryFn: getSubscriptions,
    staleTime: 2 * 60 * 1000,
    refetchInterval: options?.refetchInterval,
  });
}

export function useChangelog(subscriptionId: string) {
  return useQuery<ChangelogEntry[]>({
    queryKey: ['changelog', subscriptionId],
    queryFn: () => getChangelog(subscriptionId),
    staleTime: 2 * 60 * 1000,
    enabled: !!subscriptionId,
  });
}
